export const isMobile = (): boolean => {
    return window.matchMedia('(max-width: 1024px)').matches;
};

export const isDesktop = (): boolean => {
    return window.matchMedia('(min-width: 1025px)').matches;
};

export const isTabletPortrait = (): boolean => {
    return window.matchMedia('(max-width: 960px)').matches;
};
